import { Component, OnInit,Input } from '@angular/core';
import {
  
  ModalController,
 
} from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-seller-form-review',
  templateUrl: './seller-form-review.component.html',
  styleUrls: ['./seller-form-review.component.scss'],
})
export class SellerFormReviewComponent  implements OnInit {

  @Input() form_value;

  constructor(public modalCtrl:ModalController, public db:DataService) { }

  ngOnInit() {}

  close_modal(){
    // this.db.centres_list = [];
    let data = {'status':"success"}
      this.modalCtrl.dismiss(data);
  }

}